import { render, staticRenderFns } from "./BottomControls.vue?vue&type=template&id=6b431024&scoped=true"
import script from "./BottomControls.vue?vue&type=script&lang=js"
export * from "./BottomControls.vue?vue&type=script&lang=js"
import style0 from "./BottomControls.vue?vue&type=style&index=0&id=6b431024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b431024",
  null
  
)

export default component.exports